// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3W8Gj","amount":"Amount_amount__1Gdnb","tip":"Amount_tip__1ONTj","tipHeader":"Amount_tipHeader__1CCpk","tipsWrap":"Amount_tipsWrap__2SLAx"};